import React from "react";
import "../styles/About.css"; // Reuse same CSS
// import OurCourses from "../components/OurCourses/OurCourses";
import AllCourses from "../components/AllCourses/AllCourses"
const Courses = () => {
  return (
    <>
    <section className="banner_area">
      <div className="banner_inner d-flex align-items-center">
        <div className="overlay bg-parallax"></div>
        <div className="container">
          <div className="banner_content text-center">
            <h2>Courses</h2>
            <div className="page_link">
              <a href="/">Home</a>
              <span className="breadcrumb-arrow">→</span>
              <a href="/courses">Courses</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <AllCourses/>
    </>
  );
};

export default Courses;
